import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { FONTS, PRIMARY_COLOR } from "../constants";
import ErrorIcon from "@material-ui/icons/Error";
import { FacebookShareButton, FacebookIcon } from "react-share";
import { TwitterShareButton, TwitterIcon } from "react-share";
import { LinkedinShareButton, LinkedinIcon } from "react-share";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			fontFamily: FONTS,
			marginBottom: "40px",
			backgroundColor: PRIMARY_COLOR,
			color: "white",
			fontWeight: "bold",
			boxShadow:
				"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
			borderRadius: "10px",
			height: "50px",
			lineHeight: "50px",
			whiteSpace: "nowrap",
			display: "flex",
			maxWidth: "1200px",
			width: "75vw",
		},
	})
);

var quote = "Predictive analytics, 100% free with no-code. Check it out!";

export function ShareBanner() {
	var classes = useStyles();
	return (
		<div className={classes.wrapper}>
			<div style={{ marginLeft: "20px" }}>
				<ErrorIcon
					style={{
						marginTop: "7px",
						marginBottom: "-7px",
						marginRight: "8px",
						width: "25px",
						height: "25px",
					}}
				></ErrorIcon>
				Dash AI is a 100% free machine learning toolbox, all we ask is
				to spread the word. Share us on social!{" "}
			</div>
			<FacebookShareButton
				url={"https://www.dash-ai.app"}
				quote={quote}
				hashtag="#dashai"
			>
				<FacebookIcon
					style={{
						marginTop: "8px",
						marginBottom: "-6px",
						marginLeft: "15px",
					}}
					size={32}
					round
				/>
			</FacebookShareButton>
			<TwitterShareButton url={"https://www.dash-ai.app"} title={quote}>
				<TwitterIcon
					style={{
						marginTop: "8px",
						marginBottom: "-6px",
						marginLeft: "8px",
					}}
					size={32}
					round
				/>
			</TwitterShareButton>
			<LinkedinShareButton
				url={"https://www.dash-ai.app"}
				summary={quote}
				title={"Predictive Analytics"}
			>
				<LinkedinIcon
					style={{
						marginTop: "8px",
						marginBottom: "-6px",
						marginLeft: "8px",
					}}
					size={32}
					round
				/>
			</LinkedinShareButton>
		</div>
	);
}
